module.exports = __webpack_public_path__ + "static/media/1599230976526.22f63429.png";